import { useRef } from 'react';

//hook
function useMoveScroll(name: string, index: number, setActiveTab: Function) {
  const element = useRef<HTMLDivElement>(null);

  const onMoveToElement = () => {
    if (element.current?.getBoundingClientRect().top !== undefined) {
      const currentY = element.current?.getBoundingClientRect().top - 120;

      window.scroll({
        top: currentY,
        left: 0,
        behavior: 'smooth',
      });

      setActiveTab(index);
    }
  };

  return { element, onMoveToElement, name, index };
}

export default useMoveScroll;
